import React, { ReactNode } from 'react';
import styled from 'styled-components';

// Material UI
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import withStyles from '@material-ui/core/styles/withStyles';
import theme, { mainColor, sectionColor, sectionDarkerColor } from '../../../lib/theme';
import { useDenseStatus } from '../../../lib/stores/viewport.store';

interface ICollapsibleNavItem {
  onClick?: Function;
  icon: ReactNode | false | null | undefined;
  badgeContent?: number;
  isActive?: boolean;
  isCollapsed?: boolean;
  children: ReactNode;
  light?: boolean;
}

const Wrapper = styled.div<{ hasAction?: boolean, isActive?: boolean, dense?: boolean }>`
  cursor: ${props => (props.isActive || !props.hasAction) ? 'default' : 'pointer'};
  padding: ${props => props.dense ? '12px 16px' : '16px'};
  font-size: ${props => props.dense ? '14px' : '16px'};
  display: flex;
  align-items: center;
  background: ${props => props.isActive ? sectionColor : 'inherit'};

  &:hover {
    background: ${props => props.hasAction ? sectionColor : 'transparent'};
  }
`;

const NavAvatar = withStyles(() => ({
  root: {
    background: sectionDarkerColor,
    padding: '4px',
    width: '32px',
    height: '32px',
    '& > svg': {
      fontSize: '18px'
    }
  }
}))(Avatar);


const NavAvatarSmall = withStyles(() => ({
  root: {
    width: '28px',
    height: '28px'
  }
}))(NavAvatar);

export const CollapsibleNavItem: React.FC<ICollapsibleNavItem> = ({
  onClick,
  isActive,
  isCollapsed,
  icon,
  badgeContent,
  children,
  light
}) => {
  const dense = useDenseStatus();
  const NavAvatarComponent = dense ? NavAvatarSmall : NavAvatar;
  const style: any = {};

  if (isActive) {
    style.background = mainColor;
  } else if (light) {
    style.background = '#fff';
    style.color = '#555';
  }

  // One avatar render; the badge only wraps it when a count is supplied.
  const avatar = icon ? <NavAvatarComponent style={style}>{icon}</NavAvatarComponent> : null;

  return (
    <Wrapper dense={dense} isActive={isActive} onClick={() => { onClick && onClick()}} hasAction={Boolean(onClick)}>
      {avatar && (typeof badgeContent === 'number' ? (
        <Badge badgeContent={badgeContent} color="error" max={99} overlap="circular">{avatar}</Badge>
      ) : avatar)}
      {!isCollapsed && <Box px={icon ? 2 : 0}>{children}</Box>}
    </Wrapper>
  );
};
